import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import {setDispositionPenaltyFlagSave} from 'Store/OrderManagement/DispositionPenalityFlag/DispositionPenalityFlagAction';
import { GET_DISPOSITION_PENALTY_FLAG_SAVE } from 'Store/OrderManagement/DispositionPenalityFlag/DispositionPenalityFlagType';
import { apiMethod, apiType, API_URL } from 'utils';
import OrderManagementApiService from './OrderManagementApiService';
import { IPayload } from 'Model/IPayload';

function* getDispositionPenaltyFlagSaveSaga(res?: any): any {

    let payloadData : IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.OrderManagement,
        endpoint: `orders/update/dispositionflag?dispositionPenaltyFlag=${res?.payload?.dispositionPenaltyFlag}&savedBy=${res?.payload?.savedBy}`,
        payload : null
    }
    try {
        yield put(globalLoaderText("Saving the value...."));

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        if (response) {
            yield put(setDispositionPenaltyFlagSave(response));
            yield put(globalLoaderText(""));
        }

    } catch (error) {
        yield put(setDispositionPenaltyFlagSave(false))
        yield put(globalLoaderText(""));
    }
}

function* watchDataSync() {
    yield takeEvery(GET_DISPOSITION_PENALTY_FLAG_SAVE, getDispositionPenaltyFlagSaveSaga);
}

export default function* combinedSaga() {
    yield all([
        watchDataSync()
    ])
  }
